export const isSpecialSchedule = (specialSchedule) => specialSchedule?.some((item) => item.status === true);